export const SEARCH_LISTS_STORE_PREFIX = 'searchLists';

export const CLEAR_SEARCH_LIST = 'searchList/clear';
export const SEARCH_LIST_SET_LIST_ITEMS = 'searchList/searchListSetListItems';
export const SEARCH_LIST_SET_SUPPLEMENTARY = 'searchList/searchlistSetSupplementary';
export const SEARCH_LIST_SET_TOTAL_COUNT = 'searchList/searchListSetTotalCount';
